export default class ResourceTemporaryUser {
  constructor( connect, id, options ) {
    if ( typeof id === 'string' ) {
      this.id = id
    } else if ( typeof id?.id === 'string' && typeof id?.createdBy === 'string' ) {
      this.id = `${id.createdBy}::${id.id}`
    } else if ( typeof id?.id === 'string' ) {
      this.id = id.id
    } else {
      throw new Error( 'invalid temporary user' )
    }
    if ( options?.idOnly ) {
      this.connect = connect.child( this.id )
    } else {
      this.connect = connect.child( `${options.childPrefix}${options.divider ?? '/'}temporaryUser` ).child( this.id )
    }
  }

  get( opts ) {
    return this.connect.get( opts )
  }

  delete( body, opts ) {
    return this.connect.delete( body, opts )
  }

  update( body, opts ) { 
    return this.connect.patch( body, opts )
  }

  renew( body, opts ) {
    return this.connect.child( 'renew' ).post( body, opts )
  }

  revoke( body, opts ) {
    return this.connect.child( 'revoke' ).post( body, opts )
  }

  share( body, opts ) {
    return this.connect.child( 'share' ).post( body, opts )
  }
}
